import {AxiosError} from 'axios'
import {useIntl} from 'react-intl'
import {
  useSelectDeviceId,
  useSelectInputSectionValue,
  useSelectInputSectionValueType,
} from '../../../_metronic/layout/core'
import {awsHomePublishData, awsHomePublishDataMulti} from '../../modules/auth/core/_requests'
import {UnsuccessfulNotify} from '../../../ToastMetods'

function Button({
  item,
  index1,
  index2,
  title,
  deviceCode,
  countButton,
  experimentId,
  circuitId,
}: any) {
  //const localSelectDevice = Number(window.localStorage.getItem('selectDevice'))
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  const {SelectInputSectionValue, setSelectInputSectionValue} = useSelectInputSectionValue()
  const {SelectInputSectionValueType} = useSelectInputSectionValueType()
  const {SelectDeviceId} = useSelectDeviceId()
  const intl = useIntl()

  function handleSetList(value: any) {
    const newData = SelectInputSectionValue // controlList'in kopyasını oluşturuyoruz
    if (newData && newData[index1] && newData[index1][index2]) {
      newData[index1][index2] = value
    } else {
      console.error('Geçersiz indeksler!')
    }
    return newData
  }

  type NestedArray = (number | NestedArray)[]
  function flattenNestedArray(arr: NestedArray): number[] {
    const result: number[] = []

    if (arr.length > 0) {
      arr.forEach((item1: any) => {
        if (Array.isArray(item1) && item1.length > 0) {
          item1.forEach((item2) => {
            if (Array.isArray(item2) && item2.length > 0) {
              item2.forEach((value) => {
                result.push(value)
              })
            }
          })
        }
      })
    }
    return result
  }

  function buttonHandler(value: any) {
    if (localSelectDevice) {
      const editedData = calculateArrayValue(value) // Gelen String Veriyi Dizi Şekline Çeviriyor.
      let newList = handleSetList(editedData) // Matriks de İlgili konuma ekliyor.
      //
      let sendValue = flattenNestedArray(newList) // Tek Buton İçin Gönderilecek Veriyi Hazırla.
      setSelectInputSectionValue(newList)

      let printList: any
      if (countButton > 1) {
        const result: number[] = []

        // Indeksi 3 (Button) Olmayan değerlerin indexlerini al
        const notThreeIndexes: number[] = []
        for (let i = 0; i < SelectInputSectionValueType.length; i++) {
          if (SelectInputSectionValueType[i] !== 3) {
            notThreeIndexes.push(i)
          }
        }

        // Her bir 3 (Button) olmayan indeksteki değerleri sonuç dizisine ekle
        for (let index of notThreeIndexes) {
          let data = SelectInputSectionValue[0][index]

          if (data) {
            for (let value of Object.values(data)) {
              result.push(value)
            }
          }
        }

        for (let l of editedData) {
          result.push(l)
        }

        printList = result
        //Birden Fazla Buton var ise
      } else {
        printList = sendValue
        //Tek Buton var ise
      }

      sendAwsData(printList)
      // sendAwsData(sendValue)
      //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
      // console.log(printList)
      //
    } else {
      UnsuccessfulNotify(intl.formatMessage({id: 'DEVICE.SELECTION'}))
    }
  }

  const calculateArrayValue = (e: any) => {
    const value = e
    const regex = /\[(.*?)\]/g
    const result: any = []

    let match: any
    while ((match = regex.exec(value))) {
      let strx = match[1]
      let data = strx.split(',').map(Number)
      result.push(data)
    }
    return result
  }

  const sendAwsData = async (numArr: any) => {
    try {
      /* const deviceId = localSelectDevice ?? 0
      const {data} = await awsPublishData(deviceId, {
        device: deviceCode,
        degerlers: numArr,
      })*/

      if (SelectDeviceId.length > 0) {
        /* const requests = SelectDeviceId.map(async (id) => {
          try {
            // Her bir id için ayrı ayrı awsPublishData fonksiyonunu çağırıyoruz
            const response = await awsHomePublishData(id, experimentId, circuitId, {
              device: deviceCode,
              degerlers: numArr,
            })

            return response.data
          } catch (err) {
            // İstek sırasında bir hata olursa, hata nesnesini diziye ekliyoruz
            return Promise.reject(err)
          }
        })*/
        const {data} = await awsHomePublishDataMulti(experimentId, circuitId, SelectDeviceId, {
          device: deviceCode,
          degerlers: numArr,
        })

        // Tüm istekler tamamlandığında çalışacak kod
        // const results = await Promise.all(requests)
        //  console.log(results) // Tüm sonuçları görebilirsiniz
      } else {
        console.error('SelectDeviceId boş!')
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const longestKey = item.reduce((longest: any, button: any) => {
    const keyLength = button.key.length + 5

    return keyLength > longest ? keyLength : longest
  }, 0)

  const ButtonItem = item.map((item: any) => (
    <div
      className=' d-flex form-check orm-check-danger form-check-solid me-5 col-12 my-4'
      key={item.id}
    >
      <button
        type='button'
        className='btn btn-secondary btn-block'
        onClick={() => buttonHandler(item?.value)}
        style={{width: `${longestKey}ch`}}
      >
        {item?.key}
      </button>
    </div>
  ))

  return (
    <div
      className='col-xl-4 col-12 sal-animate'
      data-sal-delay='200'
      data-sal='slide-up'
      data-sal-duration='500'
    >
      <div className='card card-flush h-100' style={{backgroundColor: '#FFE896'}}>
        <div className='card-header pt-5'>
          <h3 className='card-title text-gray-800 fw-bolder'>{title}</h3>
        </div>
        <div className='card-body pt-0'>
          <div className='d-flex mt-3 justify-content-between p-5 rounded bg-body row'>
            {ButtonItem}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Button
